var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSteps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.66 1.996c-3.551 0-6.43 3.582-6.43 8 0 2.459.8 5.066 1.608 9.092.629 3.154 2.159 5.767 4.823 5.767s4.448-1.743 4.448-4.928c0-1.085-1.181-2.813-1.233-4.287-.1-2.66 2.361-3.721 2.361-6.179 0-4.419-2.025-7.465-5.576-7.465Zm17.351 9.144c-3.551 0-5.576 3.046-5.576 7.465 0 2.459 2.456 3.52 2.361 6.179-.052 1.474-1.233 3.2-1.233 4.287 0 3.185 1.785 4.928 4.448 4.928s4.194-2.614 4.823-5.767c.8-4.026 1.608-6.633 1.608-9.092-.001-4.418-2.88-8-6.431-8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h36v36H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteps);
export default __webpack_public_path__ + "static/media/steps.3b2899591c3466a6aaeeb9bdd8498021.svg";
export { ForwardRef as ReactComponent };